import { render, staticRenderFns } from "./accept-terms.vue?vue&type=template&id=69054699&"
import script from "./accept-terms.vue?vue&type=script&lang=js&"
export * from "./accept-terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports